import React, { useState } from "react";
import { ImageOff } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const unavailableImages = new Set();

// Use the original product photo directly. The AI re-staging endpoint is
// intentionally opt-in because a missing generated cache produced a 404 for
// every product card before the original could load.
export const NoBgImage = ({ article, className }) => {
  const original = article.images_url?.[0] || article.photo_url;
  const orig = original?.startsWith("/") ? `${BACKEND_URL}${original}` : original;
  const [failed, setFailed] = useState(() => new Set());
  const available = (url) => url && !failed.has(url) && !unavailableImages.has(url);
  const src = available(orig) ? orig : null;
  if (!src) return <div className={`${className || ""} flex flex-col items-center justify-center gap-2 text-gray-400 bg-[#12121a]`} data-testid={`product-image-unavailable-${article.id}`} role="img" aria-label={`Immagine non disponibile: ${article.title}`}><ImageOff className="h-8 w-8" aria-hidden="true" /><span className="text-xs text-center px-3">Immagine non disponibile</span></div>;
  return (
    <img
      src={src}
      alt={article.title}
      loading="lazy"
      className={className}
      onError={() => { unavailableImages.add(src); setFailed((previous) => new Set([...previous, src])); }}
    />
  );
};

export default NoBgImage;
